(() => {
  const config = document.getElementById('collection-search-shortcut');
  if (!config) return;
  const search = new URL(config.dataset.searchUrl, window.location.origin);
  const target = new URL(config.dataset.collectionUrl, window.location.origin);
  if (target.origin !== window.location.origin) return;
  const matches = value => ['ua full set/deck', 'ua full set', 'ua deck'].includes(
    String(value || '').normalize('NFKC').toLowerCase()
      .trim().replace(/\s+/g, ' ').replace(/\s*\/\s*/g, '/'));

  if (window.location.pathname === search.pathname &&
      matches(new URLSearchParams(window.location.search).get('q'))) {
    window.location.replace(target.href);
    return;
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'get') return;
    const action = new URL(form.action, window.location.origin);
    if (action.origin !== search.origin || action.pathname !== search.pathname) return;
    if (!matches(new FormData(form).get('q'))) return;
    event.preventDefault();
    window.location.assign(target.href);
  });
})();
